import { css, styled } from 'styled-components';
import mediaQuery, { Breakpoint, breakpoints } from '@/styles/mediaQuery';

export const Title = styled.h2`
  ${({ theme }) => css`
    font-size: ${theme.typography.sizes.lg};

    ${mediaQuery.xs} {
      font-size: ${theme.typography.sizes.sm};
      margin-bottom: ${theme.spaces.padding.sm};
    }
  `}
`;

export const InputContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spaces.padding.md};
`;

export const LinkContainer = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  flex-direction: column;

  ${mediaQuery.custom(breakpoints[Breakpoint.XS])} {
    align-items: center;
  }
`;

export const SubmitButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: ${({ theme }) => theme.spaces.padding.lg};
`;

export const StyledErrorMessage = styled.div`
  position: relative;
  padding: ${({ theme }) => theme.spaces.padding.md};
  margin-top: ${({ theme }) => theme.spaces.padding.md};
  color: ${({ theme }) => theme.system.error.text.primary};
  background-color: ${({ theme }) => theme.system.error.surface.subtle};
  border: 1px solid ${({ theme }) => theme.system.error.border.primary};
  border-radius: ${({ theme }) => theme.radius.small};
`;
